/**
 * ウォーターマーク再適用の共通ヘルパー関数
 * タイムスタンプベースの設定変更検知メカニズムで使用
 */

import { isWatermarkEnabled, isAnnotationEnabled } from './watermark';

interface WatermarkReapplyParams {
  watermarkGlobalEnabled: boolean;
  selectedAfterImages: any[];
  watermarkSettings: any;
  dispatch: any;
  clearAllWatermarksAction: any;
  applyWatermarkToImageAction: any;
  setWatermarkGlobalEnabledAction: any;
}

/**
 * ウォーターマーク設定が更新された際の再適用処理
 * Promise.allSettledを使用してエラーハンドリングを改善
 */
export async function reapplyWatermarksOnSettingsChange(params: WatermarkReapplyParams): Promise<void> {
  const {
    watermarkGlobalEnabled,
    selectedAfterImages,
    watermarkSettings,
    dispatch,
    clearAllWatermarksAction,
    applyWatermarkToImageAction,
    setWatermarkGlobalEnabledAction
  } = params;

  if (watermarkGlobalEnabled && selectedAfterImages.length > 0 && watermarkSettings && (isWatermarkEnabled(watermarkSettings) || isAnnotationEnabled(watermarkSettings))) {

    // 既存のウォーターマークをクリア
    dispatch(clearAllWatermarksAction());

    // 新しい設定で再適用
    const promises = selectedAfterImages.map((image: any) => {
      if (image.serverURI) {
        return dispatch(applyWatermarkToImageAction({
          imageId: image.id,
          imageUrl: image.serverURI
        }));
      }
      return Promise.resolve();
    });

    const results = await Promise.allSettled(promises);

    // エラーがあった場合のみログ出力
    const failures = results.filter(result => result.status === 'rejected');
    if (failures.length > 0) {
      console.error('Some watermarks failed to apply:', failures);
    }
    // 設定更新時は通知を出さない
  } else if (watermarkGlobalEnabled && selectedAfterImages.length > 0 && !isWatermarkEnabled(watermarkSettings) && !isAnnotationEnabled(watermarkSettings)) {
    // ウォーターマーク設定が無効になった場合は、ウォーターマークをクリア
    dispatch(clearAllWatermarksAction());
    dispatch(setWatermarkGlobalEnabledAction(false));
  }
}